import React from "react";
import { Navigate } from "react-router-dom";

export const AuthProtected = ({
  children
}) => {

  const token =
    localStorage.getItem(
      "superadmin_token"
    );

  if (!token) {

    return (
      <Navigate
        to="/login"
        replace
      />
    );

  }
  return children;


};